import React, {useEffect, useState} from "react";

const INITIAL_OFFSET_VALUE = 0

export function useVideoOffsetTop(videoRef: React.RefObject<HTMLVideoElement>) {
  const [videoOffsetTop, setVideoOffsetTop] = useState(INITIAL_OFFSET_VALUE);

  const measureOffsetTop = () => {
    const interval = setInterval(() => {
      const el = videoRef.current;
      if (!el) return;

      setVideoOffsetTop(el.offsetTop);
    }, 500);

    return interval;
  }

  useEffect(() => {
    const interval = measureOffsetTop();
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    let permissionQuery: PermissionStatus;
    let interval: NodeJS.Timeout;

    const subscribeToCameraPermission = async () => {
      try {
        permissionQuery = await navigator.permissions.query({ name: 'camera' });
        permissionQuery.onchange = () => {
          interval = measureOffsetTop()
        };
      } catch { /* empty */ }
    };

    void subscribeToCameraPermission();

    return () => {
      if (permissionQuery) {
        permissionQuery.onchange = null;
      }
      clearInterval(interval)
    };
  }, []);

  /**
   * If the offset is too large (more than half of the screen),
   * we assume that the video has not yet loaded and expanded to full size.
   * In this case, to avoid jumps in the design, we leave the offset
   * in its initial value.
   */
  const adjustedVideoOffsetTop = videoOffsetTop > 300 ? INITIAL_OFFSET_VALUE : videoOffsetTop;

  return adjustedVideoOffsetTop;
}